import React from 'react';
import {createRoot} from 'react-dom/client';
import HorizontalNavigation from './common/components/horizontal-navigation';
import Letters from './common/components/letters';
import AbcList from './common/components/abc-list';
import {type Department, SiteFilter} from './common/types/types';
import themeDisplay from "./common/services/liferay/theme-display";

const App = () => {
	const [selected, setSelected] = React.useState(SiteFilter.ADULTS);
	const [departments, setDepartments] = React.useState<Department[]>([]);

	function addSiteFilters(department: Department) {
		department.siteFilter = [];

		for (const foundSiteFilter of department.type.values()) {
			switch (foundSiteFilter.key) {
				case 'volwassenen': {
					department.siteFilter.push(SiteFilter.ADULTS);
					break;
				}

				case 'kinderen': {
					department.siteFilter.push(SiteFilter.KIDS);
					break;
				}

				case 'nietmedisch': {
					department.siteFilter.push(SiteFilter.NONMEDICAL);
					break;
				}

				default: {
					break;
				}
			}
		}
	}

	function processDepartments(foundDepartments: Department[]) {
		setDepartments(
			foundDepartments.map(department => {
				department.label = themeDisplay.getLanguageId() === 'nl_NL' ? department.naamNL : (department.naamFR ? department.naamFR : department.naamNL);
				addSiteFilters(department);
				return department;
			})
		);
	}

	function getDepartments(): void {
		fetch('/o/c/abcdiensts/?fields=link%2CnaamNL%2CnaamFR%2Ctype&flatten=true&restrictFields=actions&pageSize=200&sort=naamNL')
			.then(response => response.json())
			.then(data => {
				processDepartments(data.items);
			});
	}

	function getSelectedFromUrl() {
		const url = new URL(window.location.href);
		const filterValue = url.searchParams.get('filter');

		console.log('getSelectedFromUrl, filterValue: ', filterValue);

		switch (filterValue) {
			case 'volwassenen': {
				console.log('setSelected(SiteFilter.ADULTS)')
				setSelected(SiteFilter.ADULTS)
				break;
			}

			case 'kinderen': {
				console.log('setSelected(SiteFilter.KIDS)')
				setSelected(SiteFilter.KIDS)
				break;
			}

			case 'nietmedisch': {
				console.log('setSelected(SiteFilter.NONMEDICAL)')
				setSelected(SiteFilter.NONMEDICAL)
				break;
			}

			default: {
				break;
			}
		}
	}

	React.useEffect(() => {
		console.log('useEffect')
		getDepartments();
		getSelectedFromUrl();
	}, []);

	return (
		<section className='abc-site-overview'>
			<HorizontalNavigation departments={departments} selectedFilter={selected} onSelected={setSelected}/>
			<Letters selectedFilter={selected} departments={departments}/>
			<AbcList selectedFilter={selected} departments={departments}/>
		</section>
	);
};

class WebComponent extends HTMLElement {
	connectedCallback() {
		createRoot(this).render(<App></App>);
	}
}

const elementId = 'uzb-abc-search-custom-element';

if (!customElements.get(elementId)) {
	customElements.define(elementId, WebComponent);
}
